import { useTheme } from "@/contexts/ThemeContext";
import { RefreshCw } from "lucide-react";

/**
 * Shows "Updated" badge on offer cards when a meaningful change occurred
 * in the last 7 days. Badge color follows current mode theme.
 */
export default function UpdatedBadge({ freshness }) {
  const { theme } = useTheme();
  if (!freshness) return null;

  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold"
      style={{
        backgroundColor: `${theme.primary}12`,
        color: theme.primary,
        border: `1px solid ${theme.primary}30`,
      }}
      data-testid="updated-badge"
    >
      <RefreshCw className="w-2.5 h-2.5" />
      Updated
    </span>
  );
}
